import { render, staticRenderFns } from "./ClaimProductDuplicationTypeField.vue?vue&type=template&id=71f04699"
import script from "./ClaimProductDuplicationTypeField.vue?vue&type=script&lang=js"
export * from "./ClaimProductDuplicationTypeField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports